<template>
  <div>
    <div
      class="modal-backdrop fade show hemolife-loading-backdrop"
      role="status"
      aria-live="polite"
    >
      <span class="sr-only">Cargando contenido, por favor espere</span>
      <div class="row justify-content-center h-100">
        <div class="align-self-center hemolife-loading-inner">
          <div class="hemolife-loading-orbit">
            <div class="hemolife-loading-ring hemolife-loading-ring--outer" aria-hidden="true" />
            <div class="hemolife-loading-ring hemolife-loading-ring--inner" aria-hidden="true" />
            <div class="hemolife-loading-logo">
              <img
                src="/img/Logo-Hemolife.png"
                alt=""
                width="120"
                height="120"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
};
</script>

<style>
.hemolife-loading-backdrop {
  z-index: 10000;
  background-color: rgba(30, 41, 59, 0.78) !important;
}

.align-self-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
}

.hemolife-loading-inner {
  padding: 1rem;
}

/* Contenedor: anillos + logo centrado */
.hemolife-loading-orbit {
  position: relative;
  width: 176px;
  height: 176px;
  margin: 0 auto;
}

/* Anillo exterior: gradiente Hemolife que gira */
.hemolife-loading-ring--outer {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, 0.1);
  border-top-color: #e53538;
  border-right-color: #4e6990;
  animation: hemolife-orbit-spin 0.85s cubic-bezier(0.45, 0.05, 0.55, 0.95)
    infinite;
  box-shadow: 0 0 32px rgba(229, 53, 56, 0.15);
}

/* Anillo interior: más fino, giro contrario */
.hemolife-loading-ring--inner {
  position: absolute;
  inset: 10px;
  border-radius: 50%;
  border: 2px solid transparent;
  border-bottom-color: rgba(255, 255, 255, 0.45);
  border-left-color: rgba(78, 105, 144, 0.6);
  animation: hemolife-orbit-spin 1.25s linear infinite reverse;
}

.hemolife-loading-logo {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  pointer-events: none;
}

/* Logo en blanco (silueta) */
.hemolife-loading-logo img {
  display: block;
  width: 92px;
  max-width: min(44vw, 120px);
  height: auto;
  filter: brightness(0) invert(1)
    drop-shadow(0 6px 20px rgba(0, 0, 0, 0.35));
}

@keyframes hemolife-orbit-spin {
  to {
    transform: rotate(360deg);
  }
}

@media (prefers-reduced-motion: reduce) {
  .hemolife-loading-ring--outer,
  .hemolife-loading-ring--inner {
    animation-duration: 2s;
  }
}
</style>

